import React, { useEffect,  useRef, useState } from "react";
import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { format } from "date-fns";
import MillstageFilterBox from "../../../components/FilterBox/Millstage/MillstageFilter";
import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { Loader } from "../../../components/Loader/Loader";
import MillstageTable from "../../../components/Tables/MillstageTable";
import {
  GrpWiseStagWiseBalance,
  GrpWiseStagWiseBalanceFun,
  StageFilters,
} from "../../../Redux/Slice/Millstage/MillstageSlice";
import Calendar from "react-calendar";
import { useTheme } from "../../../Themecontext/Themecontext";
import MillStageCelender from "../../../components/Calendar/MillstageCelender";

export const GroupWiseStageWiseBalance = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StageFiltersdata, GrpWiseStagWiseBalancedata } = useSelector(
    (state) => state.MillstageSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGEDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const [filter, setFilter] = useState({
    productionGroup: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
  });
  const productionGroupList =
    StageFiltersdata?.ProdGrp?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  useEffect(() => {
    if (!startDate || !endDate) return;
    dispatch(StageFilters());
    dispatch(
      GrpWiseStagWiseBalance({
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [dispatch, startDate, endDate]);

  // 🔷 Date
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      const updatedSelected = selected.includes(item.value)
        ? selected.filter((i) => i !== item.value)
        : [...selected, item.value];

      if (type === "productionGroup") {
        if (!startDate || !endDate) return prev;

        dispatch(GrpWiseStagWiseBalanceFun());

        dispatch(
          GrpWiseStagWiseBalance({
            GroupIds: updatedSelected.join(","),
            StartDate: safeFormat(startDate),
            EndDate: safeFormat(endDate),
          }),
        );
      }

      return {
        ...prev,
        [type]: updatedSelected,
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const columns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "StageName",
      key: "StageName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
  ];

  const rows = (GrpWiseStagWiseBalancedata?.Data || []).map((row) => ({
    StageName: row?.StageName,
    Taka: row?.Taka,
    Meter: row?.Meter,
  }));

  if (!StageFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!GrpWiseStagWiseBalancedata || GrpWiseStagWiseBalancedata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <Row>
        {/* 🔷 Mobile Filter Button */}
        <Col xs={12} className="d-lg-none mb-2 text-end">
          <Button
            onClick={handleShow}
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              border: "none",
              borderRadius: "10px",
              padding: "8px 12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
            }}
          >
            <FiMenu size={22} />
          </Button>
          <Offcanvas
            show={showFilter}
            onHide={handleClose}
            style={{
              background:
                isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
            }}
          >
            <Offcanvas.Header closeButton
              closeVariant={isdark === "dark" ? "white" : undefined}
              style={{ color: isdark === "light" ? "#000" : "#FFF", }}
            >
              <Offcanvas.Title

              >
                Filters
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour6,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour9,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#fff",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
              <MillstageFilterBox
                title="Production Group"
                items={productionGroupList}
                search={search.productionGroup}
                setSearch={(val) => handleSearch("productionGroup", val)}
                selectedItems={filter.productionGroup}
                toggleItem={(item) => toggleItem("productionGroup", item)}
                selectAll={() =>
                  selectAll("productionGroup", productionGroupList)
                }
              />
            </Offcanvas.Body>
          </Offcanvas>
        </Col>

        {/* 🔷 Desktop Filter */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Date */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour6,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour9,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#fff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            {/* Filters */}
            <MillstageFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />
          </div>
        </Col>

        {/* 🔷 Offcanvas */}

        {/* 🔷 Table Section */}
        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",

              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              GROUPWISE STAGEWISE BALANCE
            </div>

            <MillstageTable columns={columns} data={rows} />
          </div>
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MillStageCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour10,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupWiseStageWiseBalance;
